import useCustomerPlan from '../../../../utils/hooks/useCustomerPlan';
import { useBootstrapSelector } from '../../../../redux/selectorHooks';
import * as PlanDetailsUI from '../PlanDetailsUI';
import { PlanHighlightContent } from '../PlanDetailsUI';
import PlanProgressBar from '../PlanProgressBar';
import { SvgIcon } from '../../../../components/Icon';
import React from 'react';
import PlanFeatures from '../PlanFeatures';
import NoPlan from '../NoPlan';
import { PlanActions } from '../PlanActions';
import { globalFormat } from '../../../../utils/formatting';
import { formatNumberCompactShort, formatPeriod } from '../PlanUtils';

const PlanSummary = () => {
  const { mtuPlan: plan, maxSchemas, maxSeats } = useCustomerPlan();
  const customerName = useBootstrapSelector('customerName');
  const { locale } = globalFormat.getGlobalFormat();

  if (!plan) {
    return <NoPlan customerName={customerName} />;
  }

  const showAllotment = !maxSeats && !maxSchemas;
  return (
    <PlanDetailsUI.Details>
      <PlanDetailsUI.Header>
        <PlanDetailsUI.Title>Kubit Plan</PlanDetailsUI.Title>
        <PlanDetailsUI.CustomerName>{customerName}</PlanDetailsUI.CustomerName>
      </PlanDetailsUI.Header>
      <PlanDetailsUI.PlanHighlightsContainer>
        <PlanDetailsUI.PlanHighlights>
          {showAllotment && (
            <PlanDetailsUI.PlanHighlight>
              <PlanDetailsUI.PlanHighlightTitle>
                Annual MTU allotment
              </PlanDetailsUI.PlanHighlightTitle>
              <PlanHighlightContent>
                {plan?.mtuLimit
                  ? formatNumberCompactShort(plan.mtuLimit * 12, locale)
                  : 'N/A'}
              </PlanHighlightContent>
            </PlanDetailsUI.PlanHighlight>
          )}
          <PlanDetailsUI.PlanHighlight>
            <PlanDetailsUI.PlanHighlightTitle>
              Contract period
            </PlanDetailsUI.PlanHighlightTitle>
            <PlanHighlightContent>
              {formatPeriod(plan.contractPeriod.start, plan.contractPeriod.end)}
            </PlanHighlightContent>
          </PlanDetailsUI.PlanHighlight>
          <PlanDetailsUI.PlanHighlight>
            <PlanDetailsUI.PlanHighlightTitle>
              Overage charge
            </PlanDetailsUI.PlanHighlightTitle>
            <PlanHighlightContent>{plan.overageCharge}</PlanHighlightContent>
          </PlanDetailsUI.PlanHighlight>
        </PlanDetailsUI.PlanHighlights>
        <PlanDetailsUI.Bars>
          <PlanProgressBar
            title="Scheduled refresh"
            currentValue={plan.refreshQuota.activeCount}
            maxValue={plan.refreshQuota.limit || 0}
          />
          <PlanProgressBar
            title="Schemas"
            isUnlimited={!maxSchemas}
            currentValue={maxSchemas?.usedSchemas || 0}
            maxValue={maxSchemas?.maxSchemas || 0}
          />
          <PlanProgressBar
            title="Users"
            isUnlimited={!maxSeats}
            currentValue={maxSeats?.occupiedSeats || 0}
            maxValue={maxSeats?.maxSeats || 0}
          />
        </PlanDetailsUI.Bars>
        {!!plan.included.length && (
          <PlanFeatures
            features={plan.included}
            title="Included in plan:"
            icon={
              <PlanDetailsUI.IncludedIcon size={24}>
                <SvgIcon name="check" customFill="currentColor" />
              </PlanDetailsUI.IncludedIcon>
            }
          />
        )}
      </PlanDetailsUI.PlanHighlightsContainer>
      {!!plan.notIncluded.length && (
        <PlanFeatures
          features={plan.notIncluded}
          title="Not included in plan:"
          icon={
            <PlanDetailsUI.NoneIncludedIcon size={24}>
              <SvgIcon name="icon-x-circle" customFill="currentColor" />
            </PlanDetailsUI.NoneIncludedIcon>
          }
        />
      )}
      <PlanActions />
    </PlanDetailsUI.Details>
  );
};

export default PlanSummary;
